import React from 'react';
import bootstrap from 'bootstrap/dist/js/bootstrap.min';

class Modal extends React.Component {

  constructor(props) {
    super(props);
    this.modal = null;
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.modal = new bootstrap.Modal(this.ref.current, {focus: true});
    this.ref.current.addEventListener('hidden.bs.modal', () => {
      if (this.props.onClose) {
        this.props.onClose();
      }
    });
    this.modal.show();
  }

  componentWillUnmount() {
    this.modal.hide();
  }

  render() {
    return <div className="bs-5">
      <div className="modal" tabIndex="-1" ref={this.ref}>
        <div className={(this.props.className ? this.props.className + ' ' : '') + 'modal-dialog'}>
          <div className="modal-content">
            <div className="modal-body">
              {this.props.children}
            </div>
            <div className="modal-footer">
              {this.props.footer(() => this.modal.hide())}
            </div>
          </div>
        </div>
      </div>
    </div>;
  }

}

export default Modal;
